<script>
import TwentyService from "../../../services/twenty-service";

export default {
  name: 'ItineraryPricesContractsModal',
  data() {
    return {
      toggled: false,
      loading: false,
      uploading: false,
      contracts: [],
      dragActive: false,
      selectedFiles: [],
      // Mock API endpoints - replace with actual endpoints
      apiBaseUrl: '/api/itinerary',
    };
  },
  computed: {
    itineraryId() {
      return this.$route.params.id;
    },
    domainId() {
      return this.$route.params.domainId;
    },
  },
  // watch: {
  //   toggled(val) {
  //     if (val) {
  //       this.fetchContracts();
  //     }
  //   },
  // },
  created() {
    this.fetchContracts();
  },
  methods: {
    async fetchContracts() {
      this.loading = true;
      try {
        TwentyService.getItineraryContracts(this.itineraryId, this.domainId)
          .then((response) => {
            this.contracts = response.data.fileUrls;
          })
          .catch((error) => {
            console.error('Failed to fetch contracts:', error);
          });
      } catch (error) {
        console.error('Failed to fetch contracts:', error);
      } finally {
        this.loading = false;
      }
    },
    handleFileSelect(event) {
      const files = Array.from(event.target.files || []);
      this.addFiles(files);
    },
    handleDrop(event) {
      this.dragActive = false;
      const files = Array.from(event.dataTransfer.files || []);
      this.addFiles(files);
    },
    addFiles(files) {
      const pdfFiles = files.filter(file => file.type === 'application/pdf');
      pdfFiles.forEach(file => {
        const preview = URL.createObjectURL(file);
        this.selectedFiles.push({
          file,
          name: file.name,
          preview,
          size: this.formatFileSize(file.size),
          onedrivePath: '',
        });
      });
    },
    updateOnedrivePath(index, path) {
      this.selectedFiles[index].onedrivePath = path;
    },
    getOnedriveLink(path) {
      if (!path) return null;
      // If it's already a URL (share link), return as-is
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }
      // Convert local OneDrive path to file:// protocol for opening
      // Replace backslashes with forward slashes for URL format
      const normalizedPath = path.replace(/\\/g, '/');
      return `file:///${normalizedPath}`;
    },
    openOnedrive(contract) {
      const link = this.getOnedriveLink(contract.onedrivePath);
      if (link) {
        window.open(link, '_blank');
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / (k ** i)).toFixed(2))} ${sizes[i]}`;
    },
    removeSelectedFile(index) {
      URL.revokeObjectURL(this.selectedFiles[index].preview);
      this.selectedFiles.splice(index, 1);
    },
    async uploadContracts() {
      if (this.selectedFiles.length === 0) return;

      this.uploading = true;
      try {
        const formData = new FormData();
        const onedrivePaths = [];
        this.selectedFiles.forEach(({ file, onedrivePath }) => {
          formData.append('files', file);
          onedrivePaths.push(onedrivePath || '');
        });
        // Append OneDrive paths as JSON array
        formData.append('onedrivePaths', JSON.stringify(onedrivePaths));
        formData.append('domainId', this.domainId);
        await TwentyService.uploadItineraryContracts(this.itineraryId, formData);

        // Simulate upload delay
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Add uploaded files to contracts list (mock)
        this.selectedFiles.forEach(({ name, preview, onedrivePath }) => {
          this.contracts.push({
            id: Date.now() + Math.random(),
            name,
            url: preview,
            onedrivePath: onedrivePath || '',
            uploadedAt: new Date().toISOString().split('T')[0],
          });
        });

        this.selectedFiles = [];
        this.$emit('contracts-updated');
      } catch (error) {
        console.error('Failed to upload contracts:', error);
      } finally {
        this.uploading = false;
      }
    },
    downloadContract(contract) {
      const link = document.createElement('a');
      link.href = contract.url;
      link.download = contract.name;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async deleteContract(contract) {
      try {
        // Mock delete - replace with actual API call
        TwentyService.deleteContract(this.itineraryId, contract.id);

        const index = this.contracts.findIndex(c => c.id === contract.id);
        if (index > -1) {
          this.contracts.splice(index, 1);
        }
        this.$emit('contracts-updated');
      } catch (error) {
        console.error('Failed to delete contract:', error);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    startResize(event, index) {
      event.preventDefault();
      const container = this.$refs[`pdfContainer${index}`][0];
      const startY = event.clientY;
      const startHeight = container.offsetHeight;

      const doResize = (e) => {
        const newHeight = startHeight + (e.clientY - startY);
        if (newHeight >= 200 && newHeight <= 800) {
          container.style.height = `${newHeight}px`;
        }
      };

      const stopResize = () => {
        document.removeEventListener('mousemove', doResize);
        document.removeEventListener('mouseup', stopResize);
      };

      document.addEventListener('mousemove', doResize);
      document.addEventListener('mouseup', stopResize);
    },
  },
  beforeDestroy() {
    // Clean up object URLs
    this.selectedFiles.forEach(({ preview }) => {
      URL.revokeObjectURL(preview);
    });
  },
};
</script>

<template>
  <div class="contracts-modal-wrapper">
    <v-btn
      :loading="loading"
      :disabled="loading"
      color="secondary"
      @click="toggled = true"
    >
      <v-icon left>description</v-icon>
      Contracts
    </v-btn>

    <v-dialog
      v-if="toggled"
      v-model="toggled"
      width="1200"
      scrollable
    >
      <v-card class="contracts-modal">
        <v-card-title class="modal-header">
          <h2>Contract Documents</h2>
          <v-btn icon @click="toggled = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="modal-content">
          <!-- Upload Section -->
          <div class="upload-section">
            <h3 class="section-title">Upload New Contracts</h3>
            <div
              :class="{ 'dropzone--active': dragActive }"
              class="dropzone"
              @dragover.prevent
              @dragenter.prevent="dragActive = true"
              @dragleave.prevent="dragActive = false"
              @drop.prevent="handleDrop"
              @click="triggerFileInput"
            >
              <input
                ref="fileInput"
                type="file"
                accept="application/pdf"
                multiple
                class="hidden-input"
                @change="handleFileSelect"
              />
              <v-icon class="upload-icon">cloud_upload</v-icon>
              <p class="upload-text">
                Drop PDF files here or <span class="upload-link">browse</span>
              </p>
              <p class="upload-hint">Only PDF files are accepted</p>
            </div>

            <!-- Selected Files Preview -->
            <div v-if="selectedFiles.length > 0" class="selected-files">
              <div
                v-for="(file, index) in selectedFiles"
                :key="`selected-${index}`"
                class="selected-file-card"
              >
                <div class="selected-file-header">
                  <v-icon class="file-icon">picture_as_pdf</v-icon>
                  <div class="file-info">
                    <span class="file-name">{{ file.name }}</span>
                    <span class="file-size">{{ file.size }}</span>
                  </div>
                  <v-btn icon small @click.stop="removeSelectedFile(index)">
                    <v-icon small>close</v-icon>
                  </v-btn>
                </div>
                <div class="onedrive-input-wrapper">
                  <v-icon class="onedrive-icon" small>cloud</v-icon>
                  <input
                    :value="file.onedrivePath"
                    type="text"
                    class="onedrive-input"
                    placeholder="Paste OneDrive file path (optional)"
                    @input="updateOnedrivePath(index, $event.target.value)"
                    @click.stop
                  />
                </div>
              </div>

              <v-btn
                :loading="uploading"
                :disabled="uploading"
                color="success"
                class="upload-btn"
                @click="uploadContracts"
              >
                <v-icon left>upload</v-icon>
                Upload {{ selectedFiles.length }} file(s)
              </v-btn>
            </div>
          </div>

          <v-divider class="section-divider" />

          <!-- Existing Contracts Section -->
          <div class="contracts-section">
            <h3 class="section-title">Existing Contracts</h3>

            <div v-if="loading" class="loading-state">
              <v-progress-circular indeterminate color="primary" />
              <span>Loading contracts...</span>
            </div>

            <div v-else-if="contracts.length === 0" class="empty-state">
              <v-icon class="empty-icon">folder_open</v-icon>
              <p>No contracts uploaded yet</p>
            </div>

            <div v-else class="contracts-grid">
              <div
                v-for="(contract, index) in contracts"
                :key="contract.id"
                class="contract-card"
              >
                <div class="contract-header">
                  <div class="contract-info">
                    <v-icon class="pdf-icon">picture_as_pdf</v-icon>
                    <div class="contract-details">
                      <span class="contract-name">{{ contract.name }}</span>
                      <span class="contract-date">Uploaded: {{ contract.uploadedAt }}</span>
                      <span
                        v-if="contract.onedrivePath"
                        class="contract-onedrive-path"
                        :title="contract.onedrivePath"
                      >
                        <v-icon x-small>cloud</v-icon>
                        {{ contract.onedrivePath }}
                      </span>
                    </div>
                  </div>
                  <div class="contract-actions">
                    <v-btn
                      v-if="contract.onedrivePath"
                      icon
                      small
                      color="info"
                      title="Open in OneDrive"
                      @click="openOnedrive(contract)"
                    >
                      <v-icon small>open_in_new</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="error"
                      title="Delete contract"
                      @click="deleteContract(contract)"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </div>
                </div>

                <div
                  :ref="`pdfContainer${index}`"
                  class="pdf-preview-container"
                >
                  <iframe
                    :src="`${contract.url}#toolbar=0&navpanes=0`"
                    class="pdf-iframe"
                    frameborder="0"
                  />

                  <div class="pdf-action-buttons">
                    <v-btn
                      v-if="contract.onedrivePath"
                      class="onedrive-btn"
                      color="info"
                      small
                      fab
                      title="Open in OneDrive"
                      @click="openOnedrive(contract)"
                    >
                      <v-icon>cloud</v-icon>
                    </v-btn>
                    <v-btn
                      class="download-btn"
                      color="primary"
                      small
                      fab
                      title="Download"
                      @click="downloadContract(contract)"
                    >
                      <v-icon>download</v-icon>
                    </v-btn>
                  </div>

                  <div
                    class="resize-handle"
                    @mousedown="startResize($event, index)"
                  >
                    <v-icon small>drag_handle</v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">
.contracts-modal-wrapper {
  display: inline-block;
}

.contracts-modal {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1a365d 0%, #2d5a87 100%);
  color: white;
  padding: 16px 24px;

  h2 {
    margin: 0;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .v-btn {
    color: white;
  }
}

.modal-content {
  padding: 24px;
  overflow-y: auto;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 16px;
}

.section-divider {
  margin: 32px 0;
}

// Upload Section Styles
.upload-section {
  .dropzone {
    border: 2px dashed #cbd5e0;
    border-radius: 12px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #f8fafc;

    &:hover,
    &.dropzone--active {
      border-color: #4299e1;
      background: #ebf8ff;
    }
  }

  .upload-icon {
    font-size: 48px;
    color: #a0aec0;
    margin-bottom: 12px;
  }

  .upload-text {
    color: #4a5568;
    margin: 0;
    font-size: 1rem;
  }

  .upload-link {
    color: #4299e1;
    font-weight: 600;
  }

  .upload-hint {
    color: #a0aec0;
    font-size: 0.85rem;
    margin-top: 8px;
  }

  .hidden-input {
    display: none;
  }
}

.selected-files {
  margin-top: 20px;

  .selected-file-card {
    background: #f1f5f9;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
  }

  .selected-file-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;

    .file-icon {
      color: #e53e3e;
      margin-right: 12px;
    }

    .file-info {
      flex: 1;
      display: flex;
      flex-direction: column;

      .file-name {
        font-weight: 500;
        color: #2d3748;
      }

      .file-size {
        font-size: 0.8rem;
        color: #718096;
      }
    }
  }

  .onedrive-input-wrapper {
    display: flex;
    align-items: center;
    padding: 8px 16px 12px;
    background: #e8f4fd;
    border-top: 1px solid #e2e8f0;

    .onedrive-icon {
      color: #0078d4;
      margin-right: 8px;
    }

    .onedrive-input {
      flex: 1;
      padding: 8px 12px;
      border: 1px solid #cbd5e0;
      border-radius: 6px;
      font-size: 0.9rem;
      background: white;
      outline: none;
      transition: border-color 0.2s ease;

      &:focus {
        border-color: #0078d4;
        box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.1);
      }

      &::placeholder {
        color: #a0aec0;
      }
    }
  }

  .upload-btn {
    margin-top: 16px;
  }
}

// Contracts Section Styles
.contracts-section {
  .loading-state,
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #718096;

    .v-progress-circular {
      margin-bottom: 16px;
    }

    .empty-icon {
      font-size: 64px;
      color: #cbd5e0;
      margin-bottom: 16px;
    }
  }
}

.contracts-grid {
  display: grid;
  gap: 24px;
}

.contract-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;

  .contract-info {
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;

    .pdf-icon {
      color: #e53e3e;
      font-size: 28px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .contract-details {
      display: flex;
      flex-direction: column;
      min-width: 0;

      .contract-name {
        font-weight: 600;
        color: #2d3748;
        max-width: 400px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .contract-date {
        font-size: 0.8rem;
        color: #718096;
      }

      .contract-onedrive-path {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 0.75rem;
        color: #0078d4;
        margin-top: 4px;
        max-width: 400px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 2px 6px;
        background: #e8f4fd;
        border-radius: 4px;
        width: fit-content;

        .v-icon {
          color: #0078d4;
        }
      }
    }
  }

  .contract-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
    margin-left: 12px;
  }
}

.pdf-preview-container {
  position: relative;
  height: 400px;
  min-height: 200px;
  max-height: 800px;
  background: #f1f5f9;

  .pdf-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .pdf-action-buttons {
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 10;
    display: flex;
    gap: 8px;
  }

  .download-btn,
  .onedrive-btn {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .onedrive-btn {
    background: #0078d4 !important;
  }

  .resize-handle {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 24px;
    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ns-resize;
    transition: background 0.2s ease;

    .v-icon {
      color: #718096;
      transform: rotate(90deg);
    }

    &:hover {
      background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.2));

      .v-icon {
        color: #4a5568;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesContractsModal.vue